import _ from 'underscore';
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { LearnMoreLink } from '@bingads-webui-campaign-react/help';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { readPmaxCampaigns } from '../../conversion-goals-repository';

export const useShowPmaxAutoSwitchMessage = (aid, cid) => {
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    readPmaxCampaigns(cid, aid).then((res) => {
      const pmaxCampaigns = res.value;

      const shouldShowMessage = _.any(pmaxCampaigns, (campaign) => {
        const hasSettingsWithUseMaxClicks = _.where(campaign.CampaignSettings, { UseMaxClicks: true });

        return !_.isEmpty(hasSettingsWithUseMaxClicks);
      });

      setShowMessage(shouldShowMessage);
    });
  }, [aid, cid]);

  return showMessage;
};

const getPmaxAutoSwitchMessageStyles = () => ({
  root: {
    margin: '8px 24px',
  },
});

export const PmaxAutoSwitchMessage = ({ i18n }) => {
  const classes = useDefaultStyles(getPmaxAutoSwitchMessageStyles);

  const template = i18n.getString(_TL_('Once we track a sufficient amount of conversion data, your Performance Max campaigns will automatically switch to your selected conversion-based bid strategy. You can always change the bid strategy in the campaign\'s settings. {{link}}Learn more about bid strategy for Performance Max campaigns.{{/link}}'));

  return (
    <div className={classnames('pmax-auto-switch', 'alert', 'alert-info', classes.root)}>
      <span className="alert-image" />
      <span>
        <ReactTemplate
          model={{
            link: text => (<LearnMoreLink
              linkText={text}
              topic="ext56786"
            />),
          }}
          template={template}
        />
      </span>
    </div>
  );
};

PmaxAutoSwitchMessage.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
